export * from './applications';
export * from './avatars';
export * from './connectors';
export * from './logs';

export const themeStorageKey = 'logto:admin_console:theme';
export const requestTimeout = 20_000;
export const generatedPasswordStorageKey = 'logto:admin_console:generated_password';
